/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProjectRoleDTO } from './ProjectRoleDTO';
import {
    ProjectRoleDTOFromJSON,
    ProjectRoleDTOFromJSONTyped,
    ProjectRoleDTOToJSON,
} from './ProjectRoleDTO';

/**
 * 
 * @export
 * @interface NewOrganizationInvitationProjectEntryDTO
 */
export interface NewOrganizationInvitationProjectEntryDTO {
    /**
     * 
     * @type {string}
     * @memberof NewOrganizationInvitationProjectEntryDTO
     */
    projectIdentity: string;
    /**
     * 
     * @type {ProjectRoleDTO}
     * @memberof NewOrganizationInvitationProjectEntryDTO
     */
    role: ProjectRoleDTO;
}



/**
 * Check if a given object implements the NewOrganizationInvitationProjectEntryDTO interface.
 */
export function instanceOfNewOrganizationInvitationProjectEntryDTO(value: object): value is NewOrganizationInvitationProjectEntryDTO {
    if (!('projectIdentity' in value) || value['projectIdentity'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function NewOrganizationInvitationProjectEntryDTOFromJSON(json: any): NewOrganizationInvitationProjectEntryDTO {
    return NewOrganizationInvitationProjectEntryDTOFromJSONTyped(json, false);
}

export function NewOrganizationInvitationProjectEntryDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): NewOrganizationInvitationProjectEntryDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'projectIdentity': json['projectIdentity'],
        'role': ProjectRoleDTOFromJSON(json['role']),
    };
}

export function NewOrganizationInvitationProjectEntryDTOToJSON(value?: NewOrganizationInvitationProjectEntryDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectIdentity': value['projectIdentity'],
        'role': ProjectRoleDTOToJSON(value['role']),
    };
}

